import Vue from 'vue';

function Bucket(config) {
    if (!(this instanceof Bucket)) {
		return new Bucket(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

Bucket.prototype = {
	constructor: Bucket,

    id: '',
    name: '',
    bucketKey: '',
    accessKey: '',
    createdOn: null,
};

Bucket.fromDTO = function (dto) {
    if (dto === null || dto === undefined) {
		return null;
    }

	return new Bucket({
        id: dto.id,
        accessKey: dto.accessKey,
        bucketKey: dto.bucketKey,
        createdOn: dto.createdOn,
        name: dto.name,
	});
};

export default Bucket;



// WEBPACK FOOTER //
// ./src/modules/data/bucket.js